import {
    BTIconExclamationCircleOutlined,
    BTIconMagnifyingGlassEnrichedDark,
    BTIconMagnifyingGlassX,
} from "commonComponents/btWrappers/BTIcon";
import { emptyStateIconSize } from "commonComponents/entity/emptyState/common/EmptyState.api.types";
import { EmptyState } from "commonComponents/entity/emptyState/EmptyState";
import {
    type IGlobalSearchError,
    type IGlobalSearchState,
} from "commonComponents/utilities/MainNavigation/globalSearch/GlobalSearch.types";

import "./GlobalSearchEmptyState.less";

interface IGlobalSearchEmptyStateProps {
    searchState: IGlobalSearchState;
}

const NewState = () => {
    return (
        <EmptyState
            title="Find anything in Buildertrend"
            className="GlobalSearchEmptyState"
            image={
                <BTIconMagnifyingGlassEnrichedDark
                    size={emptyStateIconSize}
                    className="EmptyStateIcon"
                    data-testid="EmptyStateIcon"
                />
            }
        >
            Search across all open jobs or find something specific with filters.
        </EmptyState>
    );
};

const NoResults = () => {
    return (
        <EmptyState
            className="GlobalSearchEmptyState"
            image={
                <BTIconMagnifyingGlassX
                    size={emptyStateIconSize}
                    className="EmptyStateIcon"
                    data-testid="EmptyStateIcon"
                />
            }
        >
            We didn't find anything matching your search.
        </EmptyState>
    );
};

interface IErrorState {
    error: IGlobalSearchError;
}
const ErrorState: React.FunctionComponent<IErrorState> = ({ error }) => {
    return (
        <EmptyState
            className="GlobalSearchEmptyState"
            image={
                <BTIconExclamationCircleOutlined
                    size={emptyStateIconSize}
                    className="EmptyStateIcon"
                    data-testid="EmptyStateIcon"
                />
            }
        >
            {error.message}
        </EmptyState>
    );
};

export const GlobalSearchEmptyState: React.FunctionComponent<IGlobalSearchEmptyStateProps> = ({
    searchState,
}) => {
    return (
        <>
            {searchState.searchValue === "" && <NewState />}
            {searchState.results && searchState.results.length === 0 && <NoResults />}
            {searchState.error && <ErrorState error={searchState.error} />}
        </>
    );
};
